import Pusher from 'pusher-js/react-native';

class PusherSingleton {
  private static instance: PusherSingleton;
  public pusher: Pusher;

  // Private constructor to ensure singleton pattern
  private constructor(bearerToken: string) {
    // Initialize Pusher with the provided bearer token
    this.pusher = new Pusher('cce07f3a4de11ee272f4', {
      cluster: 'ap3',
      authEndpoint:
        'https://helpinghand.dev.bossdigital.tech/api/v1/broadcasting/auth',
      auth: {
        headers: {
          Authorization: `Bearer ${bearerToken}`,
        },
      },
    });
  }

  // Static method to get the instance of PusherSingleton
  // Takes bearerToken as a parameter for flexibility
  public static getInstance(bearerToken: string): PusherSingleton {
    if (!PusherSingleton.instance) {
      PusherSingleton.instance = new PusherSingleton(bearerToken);
    }
    return PusherSingleton.instance;
  }
}

export default PusherSingleton;
